/**
 * NumberField writes its formatted text back to the model on blur, so a stored value with more
 * decimals than the field shows is rounded just by focusing and leaving it. `accepts` rejects that
 * write-back: an update is dropped when nothing was typed since focus and it equals the stored value
 * rounded to the field's format. Spread `inputListeners` on the NumberFieldInput.
 */
export function useNumberFieldBlurGuard(formatOptions: Intl.NumberFormatOptions) {
  const formatter = new Intl.NumberFormat('en-US', { ...formatOptions, useGrouping: false })

  let typed = false

  const inputListeners = {
    onFocus: () => {
      typed = false
    },
    onInput: () => {
      typed = true
    },
  }

  function accepts(next: number | undefined, stored: number | null | undefined): boolean {
    if (typed || stored == null || !Number.isFinite(stored)) {
      return true
    }
    return next !== Number(formatter.format(stored))
  }

  return { inputListeners, accepts }
}
